import { render, staticRenderFns } from "./TextGuidesEditModel.vue?vue&type=template&id=6281d2cb&"
import script from "./TextGuidesEditModel.vue?vue&type=script&lang=js&"
export * from "./TextGuidesEditModel.vue?vue&type=script&lang=js&"
import style0 from "./TextGuidesEditModel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports